import * as React from 'react';

const ArrowLeft24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.015 4.23a.727.727 0 0 1-.033 1.028l-6.416 6.015h12.707a.727.727 0 1 1 0 1.454H6.566l6.416 6.015a.727.727 0 1 1-.995 1.061L4.23 12.531a.727.727 0 0 1 0-1.062l7.757-7.272a.727.727 0 0 1 1.028.033"
  }
));
ArrowLeft24.Size = 24;
ArrowLeft24.Title = "ArrowLeft";

export { ArrowLeft24 as default };
